import { Outlet } from 'react-router-dom';
import ContainerBatismoMembros from './components/container';
import { ProviderMembroBatismoContext } from './context/getServices';

export default function Membros() {

  return (
    <div style={{ display: "flex", flex: 1, padding: 5 }}>
      <ProviderMembroBatismoContext>
        <>
          <ContainerBatismoMembros />
          <Outlet />
        </>
      </ProviderMembroBatismoContext>
    </div>
  )
}
